import PimFetcher from '@/services/fetchers/Pim'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { computed, ref } from 'vue'
import _ from 'lodash'

export const usePimStore = defineStore('pim', () => {
  const references = ref([])

  const getReferences = computed(() => references.value)
  const getReferencesByKey = computed(() => key => {
    return references.value?.filter(reference => reference.key === key) ?? []
  })

  function addReferences (payload) {
    references.value = _.uniqBy([
      ...payload,
      ...(references.value ? this.references : [])
    ], r => [r.value, r.key])
  }
  function clear () {
    references.value = null
  }
  async function fetchReferences (payload) {
    const valuesToFetch = payload.values?.filter(v => {
      const existingKey = references.value?.find(r => r.key === payload.key && r.value === v)
      return v && !existingKey
    }) ?? []
    if (valuesToFetch.length) {
      const results = (await PimFetcher.get(
        payload.slug,
        {
          key: payload.key,
          refLocaleCode: payload.refLocaleCode,
          values: valuesToFetch
        }
      )).data.data

      references.value = _.uniqBy(
        _.cloneDeep(references.value || []).concat(results.map(m => ({ ...m, locale: payload.refLocaleCode }))),
        r => [r.value, r.key]
      )
    }
  }

  return {
    references,
    getReferences,
    getReferencesByKey,
    addReferences,
    clear,
    fetchReferences
  }
}, { persist: true })

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(usePimStore, import.meta.webpackHot))
}
